import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Edit package")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Deactivate package")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Activate package")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.packageColumns,
    rows: _ctx.packages,
    "row-key": "id",
    pagination: _ctx.pagination,
    "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
    flat: "",
    "visible-columns": _ctx.visibleColumns
  }, {
    "body-cell-code": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "circle",
            color: props.row.isActive ? 'positive' : 'inactive',
            class: "q-mr-md"
          }, null, 8, ["color"]),
          _createTextVNode(" " + _toDisplayString(props.row.code), 1)
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-actions": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            dense: "",
            round: "",
            flat: "",
            color: "grey",
            onClick: ($event: any) => (_ctx.onEditPackage(null, props.row)),
            icon: "edit"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_q_btn, {
            dense: "",
            round: "",
            flat: "",
            color: "grey",
            onClick: ($event: any) => (_ctx.onDeletePackage(props.row)),
            icon: "delete"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"]),
          (props.row.isActive)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_component_q_toggle, {
                  modelValue: props.row.isActive,
                  "onUpdate:modelValue": ($event: any) => ((props.row.isActive) = $event),
                  "checked-icon": "check",
                  color: "green",
                  "unchecked-icon": "clear",
                  onClick: ($event: any) => (_ctx.onDeactivatePackage(props.row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (!props.row.isActive)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createVNode(_component_q_toggle, {
                  "unchecked-icon": "clear",
                  modelValue: props.row.isActive,
                  "onUpdate:modelValue": ($event: any) => ((props.row.isActive) = $event),
                  onClick: ($event: any) => (_ctx.onActivatePackage(props.row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    _: 1
  }, 8, ["columns", "rows", "pagination", "visible-columns"]))
}